export class BenefitTileApiError extends Error {
  readonly type: string;
  constructor() {
    super('Benefit tile api error');
    this.type = 'BenefitTileApiError';
  }
}
